module.exports = new __parcel__URL__("blank-card.860b7ec3.svg").toString();